module.exports = __webpack_public_path__ + "static/media/galerija_2013 (34).8d4e7526.jpg";